import {existingCustomerSelected, queryBearerToken} from "./UserAuthentication";
import * as ActionTypes from "../constants/ActionTypes";
import {queryNewCart} from "./Cart";
import {queryTopLevelDomains} from "./Domain";
import {agencyServerArticleNumber, agencyServerCMSArticles, agencyServerProjectArticles} from "../config/Config";
import {_customerNumber, _initialSoftware} from "../selectors/GetParam";
import {toggleSelectionTriggered} from "./Util";
import {initialize as initializeForms} from "redux-form";
import {putFormData} from "./FormData";
import {appInitialized} from "./AppInit";
import {getSoftwareLoaders} from "./AppInit.SoftwareLoaders";
import {queryAddInitialProject} from "./ProjectSelection";
import {queryCustomerAccounts} from "./Accounts";
import {ARTICLE_TYPE_CMS, DOMAIN_TYPE_CUSTOM, PROJECT_STATE_LIVE} from "../constants/General";
import {activateBaseArticle} from "./BaseArticle";
import {queryArticleOptionData} from "./ArticleData";
import {selectCartProperty} from "./Properties";
import {getContractBillingPeriodNormalized} from "../selectors/Contract";

export const initializeAppAddProject = (baseArticleId, initParams) => (dispatch, getState) => {

    Promise.all([
        dispatch(queryBearerToken())
    ]).then((args) => {
        if (args[0].type !== ActionTypes.BEARER_TOKEN_FAILURE) {

            const initialCalls = [
                activateBaseArticle(agencyServerArticleNumber),
                queryNewCart(),
                queryTopLevelDomains()
            ]

            Promise.all(initialCalls.map(func => dispatch(func))).then((args) => {
                if (args[0] === true && args[1].type === ActionTypes.CART_CREATE_SUCCESS && args[2].type === ActionTypes.TOPLEVELDOMAINS_SUCCESS) {
                    Promise.all([
                        dispatch(queryCustomerAccounts(_customerNumber)),
                        ...getSoftwareLoaders(getState().articleData.baseArticle.type).map(func => dispatch(func)),
                        dispatch(queryArticleOptionData(agencyServerProjectArticles)),
                    ]).then((args) => {
                        const postInitCalls = []

                        postInitCalls.push(existingCustomerSelected())
                        postInitCalls.push(toggleSelectionTriggered('phoneVerificationType', 'phone'))
                        postInitCalls.push(toggleSelectionTriggered('domainType', DOMAIN_TYPE_CUSTOM))
                        postInitCalls.push(selectCartProperty("software", _initialSoftware ? _initialSoftware : ""));
                        postInitCalls.push(selectCartProperty('billingPeriod', 4));

                        dispatch(initializeForms('projectSelection',
                            {
                                type: ARTICLE_TYPE_CMS,
                                state: PROJECT_STATE_LIVE,
                                article: "" + agencyServerCMSArticles[1],
                                storage: "",
                                backup: 7,
                            }
                        ))
                        postInitCalls.push(queryAddInitialProject());


                        Promise.all(postInitCalls.map(func => dispatch(func))).then(args => {
                            dispatch(appInitialized(initParams))
                            dispatch(putFormData())
                        });

                    })
                }
            })
        }
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.AddProject.js
 **/